const mockDataIrons = [
  {
    Id: "4142a6ed-170b-4fd4-a4b6-f93b961a797f",
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: "4142a6ed-170b-4fd4-a4b6-f93b961a797f",
      Time: "2022-03-30T18:17:38.945278Z",
      Kind: "Measurement",
      TeePosition: [2.157145963, -0.1203743218, -0.05251557697],
      PlayerDexterity: "Right",
      AttackAngle: -1.8,
      LaunchDirection: -6.228,
      BallSpeed: 56.24,
      ClubPath: -2.2,
      ClubSpeed: 30.211,
      DynamicLoft: 24.128,
      DynamicLie: 62.2,
      FaceAngle: -7.18,
      FaceToPath: -4.98,
      LaunchAngle: 14.2,
      SmashFactor: 1.339,
      SpinAxis: -8.536,
      SpinLoft: 26.479,
      SpinRate: 4235.23,
      SwingDirection: -3.627,
      SwingPlane: 57.026,
      SwingRadius: 1.236,
      DPlaneTilt: -10.007,
      LowPointDistance: 0.046,
      LowPointHeight: -0.001,
      LowPointSide: -0.002,
      ImpactHeight: 0.0057,
      ImpactOffset: 0.0073,
      MaxHeight: 15.558,
      Curve: -5.783,
      Carry: 109.712,
      Total: 124.647,
      CarrySide: -17.635,
      TotalSide: -20.669,
      LandingAngle: 36.444958,
      HangTime: 4.461307,
      LastData: 4.023,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.05076473265, 29.51996687, 37.12893058, -2085.024379],
          YFit: [-0.009812867884, -0.8996462862, 299.5004423, 1207.388538],
          ZFit: [-0.003258066886, -1.249510135, -197.6917886, -653.9701157],
          TimeInterval: [-0.03295238442, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.05133515774, 22.27443297, -35.83562886, -702.97206],
          YFit: [-0.009719798193, -0.8365410492, 171.4507016, -588.5483144],
          ZFit: [-0.003282419561, -0.8404201735, -109.5890296, 427.859832],
          TimeInterval: [0.0, 0.05306361558],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [
            -0.0, 37.90980616, -5.717755818, 0.903744139, -0.08385329977,
            0.002720688132, 0.000142241524,
          ],
          YFit: [
            0.0, 13.50027448, -2.449915518, -0.3388768555, 0.06559981182,
            -0.004154471221, -2.744194e-6,
          ],
          ZFit: [
            -0.0, -4.137061552, -0.03756490404, 0.05026719863, -0.01300117049,
            0.001693550034, -9.3430849e-5,
          ],
          SpinRateFit: [
            4235.873139, -132.083763, 11.324829, -1.195791, 0.022459,
          ],
          TimeInterval: [0.0, 4.461307],
          MeasuredTimeInterval: [0.0, 0.100987],
          ValidTimeInterval: [0.0, 4.461307],
        },
        {
          Kind: "Bounce",
          XFit: [74.52630084, 8.438410562, -0.1954497887],
          YFit: [-120.2178164, 49.62423094, -5.082968342],
          ZFit: [-10.63696351, -1.749204903, 0.04051494377],
          TimeInterval: [4.46130699, 5.303065511],
          ValidTimeInterval: [4.46130699, 5.303065511],
        },
        {
          Kind: "Bounce",
          XFit: [74.76030968, 8.31302104, -0.1802325492],
          YFit: [-152.2883081, 55.59594882, -5.068553819],
          ZFit: [-10.68547146, -1.723212785, 0.03736054778],
          TimeInterval: [5.303065511, 5.665940792],
          ValidTimeInterval: [5.303065511, 5.665940792],
        },
        {
          Kind: "Roll",
          XFit: [96.57126175, 3.442313932],
          YFit: [0.0],
          ZFit: [-15.20668117, -0.7135600194],
          TimeInterval: [5.665940792, 7.654738431],
          ValidTimeInterval: [5.665940792, 7.654738431],
        },
      ],
    },
  },
  {
    Id: "d7e5e257-97a7-4ee3-aa24-afb0403168ec",
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: "d7e5e257-97a7-4ee3-aa24-afb0403168ec",
      Time: "2022-03-30T18:12:42.096172Z",
      Kind: "Measurement",
      TeePosition: [2.232725585, -0.119208538, -0.0009578254667],
      PlayerDexterity: "Right",
      AttackAngle: -0.4,
      LaunchDirection: -10.183,
      BallSpeed: 52.89,
      ClubPath: -1.8,
      ClubSpeed: 32.276,
      DynamicLoft: 23.788,
      DynamicLie: 66.5,
      FaceAngle: -12.538,
      FaceToPath: -10.738,
      LaunchAngle: 15.8,
      SmashFactor: 1.1623,
      SpinAxis: -19.108,
      SpinLoft: 26.328,
      SpinRate: 4447.18,
      SwingDirection: -2.161,
      SwingPlane: 63.056,
      SwingRadius: 1.012,
      DPlaneTilt: -22.459,
      LowPointDistance: 0.004,
      LowPointHeight: -0.0,
      LowPointSide: -0.0,
      ImpactHeight: 0.0256,
      ImpactOffset: -0.0135,
      MaxHeight: 11.951,
      Curve: -9.707,
      Carry: 94.229,
      Total: 110.486,
      CarrySide: -26.124,
      TotalSide: -32.053,
      LandingAngle: 32.622241,
      HangTime: 3.881261,
      LastData: 4.037,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.05555004767, 31.64428525, 40.7388212, -3814.021903],
          YFit: [-0.01911329788, -0.0735613997, 452.1430512, 2243.807796],
          ZFit: [0.01905125425, -1.111517618, -232.6513925, -999.7332176],
          TimeInterval: [-0.02866841113, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.05618577787, 23.22258009, -46.16701426, -1196.31711],
          YFit: [-0.01901275752, -0.3069278514, 242.3882021, -1038.429287],
          ZFit: [0.01902408045, -0.6871729475, -122.2036876, 574.5129575],
          TimeInterval: [0.0, 0.04536678887],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [
            0.0, 34.92965961, -5.171814136, 0.7901132045, -0.06086105486,
            -0.001423082925, 0.00050936848,
          ],
          YFit: [
            -0.0, 12.16120294, -2.778790793, -0.2638381385, 0.05961539093,
            -0.003541424926, -9.471628e-5,
          ],
          ZFit: [
            0.0, -6.274074247, -0.3959776765, 0.1466513604, -0.02998849919,
            0.003408625106, -0.000169357322,
          ],
          SpinRateFit: [
            4447.641978, -135.511213, 12.210156, -1.53981, 0.045403,
          ],
          TimeInterval: [0.0, 3.881261],
          MeasuredTimeInterval: [0.0, 0.109392],
          ValidTimeInterval: [0.0, 3.881261],
        },
        {
          Kind: "Bounce",
          XFit: [60.18396949, 8.676594201, -0.2208717115],
          YFit: [-92.99386855, 43.82723943, -5.11861828],
          ZFit: [-14.2854649, -3.384334591, 0.08615174992],
          TimeInterval: [3.881261169, 4.682563604],
          ValidTimeInterval: [3.881261169, 4.682563604],
        },
        {
          Kind: "Bounce",
          XFit: [60.33917221, 8.563842109, -0.2039893819],
          YFit: [-120.2109878, 49.56514143, -5.102557217],
          ZFit: [-14.34600225, -3.340355256, 0.07956674033],
          TimeInterval: [4.682563604, 5.031464911],
          ValidTimeInterval: [4.682563604, 5.031464911],
        },
        {
          Kind: "Roll",
          XFit: [80.53733599, 3.523067074],
          YFit: [0.0],
          ZFit: [-22.22436359, -1.374184096],
          TimeInterval: [5.031464911, 7.152131859],
          ValidTimeInterval: [5.031464911, 7.152131859],
        },
      ],
    },
  },
  {
    Id: "9a7a4dbd-47af-407d-b364-0870bf5f3360",
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: "9a7a4dbd-47af-407d-b364-0870bf5f3360",
      Time: "2022-04-22T16:49:30.357954Z",
      Kind: "Measurement",
      TeePosition: [2.073866698, -0.1296323438, -0.1486791363],
      PlayerDexterity: "Left",
      AttackAngle: -3.2,
      LaunchDirection: -4.859,
      BallSpeed: 59.18,
      ClubPath: -6.4,
      ClubSpeed: 36.451,
      DynamicLoft: 27.142,
      DynamicLie: 55.8,
      FaceAngle: -4.37,
      FaceToPath: 2.03,
      LaunchAngle: 12.7,
      SmashFactor: 1.2144,
      SpinAxis: 3.3,
      SpinLoft: 30.571,
      SpinRate: 5889.0,
      SwingDirection: -4.213,
      SwingPlane: 55.591,
      SwingRadius: 1.131,
      DPlaneTilt: 3.886,
      LowPointDistance: 0.078,
      LowPointHeight: -0.002,
      LowPointSide: -0.008,
      ImpactHeight: -0.0059,
      ImpactOffset: 0.023,
      MaxHeight: 22.689,
      Curve: 3.299,
      Carry: 121.978,
      Total: 129.836,
      CarrySide: -7.041,
      TotalSide: -7.354,
      LandingAngle: 45.221811,
      HangTime: 5.324351,
      LastData: 4.109,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.05034951209, 34.92364154, 107.2456144, -4008.177773],
          YFit: [-0.002945482603, -1.939655061, 455.3187299, 2376.157002],
          ZFit: [-0.02025992251, -3.953780646, 305.9011886, 1929.533521],
          TimeInterval: [-0.02581711582, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.0519099088, 29.17922637, -32.26872305, -1838.542453],
          YFit: [-0.002246613539, -2.023922907, 328.387138, -1531.49005],
          ZFit: [-0.01966485025, -3.579900364, 228.7200182, -917.8433456],
          TimeInterval: [0.0, 0.05190448418],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [
            0.0, 41.1322522, -7.536877283, 1.319747083, -0.1430942241,
            0.008303053283, -0.000144787815,
          ],
          YFit: [
            -0.0, 15.97852796, -1.887726053, -0.5676170919, 0.1039324228,
            -0.007818572781, 0.000177519841,
          ],
          ZFit: [
            0.0, -3.496420807, 0.9817626131, -0.2001598597, 0.02639272021,
            -0.002059811999, 6.8400296e-5,
          ],
          SpinRateFit: [
            5890.775983, -189.985157, 18.844338, -2.265254, 0.088596,
          ],
          TimeInterval: [0.0, 5.324351],
          MeasuredTimeInterval: [0.0, 0.094375],
          ValidTimeInterval: [0.0, 5.324351],
        },
        {
          Kind: "Bounce",
          XFit: [99.45459761, 4.546241055, -0.06661096657],
          YFit: [-165.1798221, 57.41392667, -4.956455748],
          ZFit: [-6.153706822, -0.180776954, 0.002648721763],
          TimeInterval: [5.324351296, 6.260489261],
          ValidTimeInterval: [5.324351296, 6.260489261],
        },
        {
          Kind: "Bounce",
          XFit: [99.76238604, 4.453782091, -0.05977000794],
          YFit: [-206.2761072, 63.93757701, -4.949880112],
          ZFit: [-6.165945686, -0.1771004269, 0.002376698763],
          TimeInterval: [6.260489261, 6.656631284],
          ValidTimeInterval: [6.260489261, 6.656631284],
        },
        {
          Kind: "Roll",
          XFit: [112.2248343, 2.183703907],
          YFit: [0.0],
          ZFit: [-6.661503147, -0.08683291008],
          TimeInterval: [6.656631284, 7.969426162],
          ValidTimeInterval: [6.656631284, 7.969426162],
        },
      ],
    },
  },
  {
    Id: "c6aba6ec-f179-44db-a9ad-9b92d591ea49",
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: "c6aba6ec-f179-44db-a9ad-9b92d591ea49",
      Time: "2022-04-22T16:50:04.338034Z",
      Kind: "Measurement",
      TeePosition: [2.103795195, -0.1343409439, -0.1416558083],
      PlayerDexterity: "Left",
      AttackAngle: -1.8,
      LaunchDirection: -2.657,
      BallSpeed: 63.53,
      ClubPath: -6.6,
      ClubSpeed: 36.751,
      DynamicLoft: 28.584,
      DynamicLie: 54.6,
      FaceAngle: -1.675,
      FaceToPath: 4.925,
      LaunchAngle: 16.9,
      SmashFactor: 1.3285,
      SpinAxis: 7.397,
      SpinLoft: 30.787,
      SpinRate: 5617.12,
      SwingDirection: -5.696,
      SwingPlane: 60.829,
      SwingRadius: 1.106,
      DPlaneTilt: 8.784,
      LowPointDistance: 0.037,
      LowPointHeight: -0.001,
      LowPointSide: -0.004,
      ImpactHeight: -0.0004,
      ImpactOffset: 0.0128,
      MaxHeight: 31.417,
      Curve: 9.683,
      Carry: 138.226,
      Total: 144.372,
      CarrySide: 3.28,
      TotalSide: 3.663,
      LandingAngle: 50.926493,
      HangTime: 6.12022,
      LastData: 4.255,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.05048574106, 35.51855576, 97.79833032, -4447.46501],
          YFit: [-0.009577524897, -0.9842287267, 513.9169494, 2664.341935],
          ZFit: [-0.0124248872, -4.143247421, 279.7507097, 1940.831689],
          TimeInterval: [-0.02590060048, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.05157256613, 26.20221598, -32.73511727, -1420.281508],
          YFit: [-0.00918899869, -1.058853961, 283.6929168, -1261.369101],
          ZFit: [-0.01209844988, -3.242845869, 163.1115795, -567.1865697],
          TimeInterval: [0.0, 0.05212819952],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [
            -0.0, 44.73487404, -8.800707901, 1.57945195, -0.1827610612,
            0.01251286011, -0.000362680331,
          ],
          YFit: [
            -0.0, 19.44892165, -1.913803284, -0.6330118419, 0.1165851107,
            -0.009242904206, 0.000258095725,
          ],
          ZFit: [
            0.0, -2.075787456, 1.289848206, -0.3042447315, 0.04518607512,
            -0.003926510716, 0.000147205532,
          ],
          SpinRateFit: [
            5619.449827, -185.699351, 17.760262, -1.839118, 0.055528,
          ],
          TimeInterval: [0.0, 6.12022],
          MeasuredTimeInterval: [0.0, 0.088557],
          ValidTimeInterval: [0.0, 6.12022],
        },
        {
          Kind: "Bounce",
          XFit: [119.6665523, 3.258023068, -0.03796698128],
          YFit: [-217.0675636, 65.63430685, -4.928973848],
          ZFit: [2.124963346, 0.2032248686, -0.002368256652],
          TimeInterval: [6.120219795, 7.197132777],
          ValidTimeInterval: [6.120219795, 7.197132777],
        },
        {
          Kind: "Bounce",
          XFit: [120.1424783, 3.147267473, -0.03183983615],
          YFit: [-270.5710187, 73.02367096, -4.922705736],
          ZFit: [2.154650089, 0.1963162884, -0.001986064831],
          TimeInterval: [7.197132777, 7.637086542],
          ValidTimeInterval: [7.197132777, 7.637086542],
        },
        {
          Kind: "Roll",
          XFit: [128.9655669, 1.74878372],
          YFit: [0.0],
          ZFit: [2.705005594, 0.1090834331],
          TimeInterval: [7.637086542, 8.783228725],
          ValidTimeInterval: [7.637086542, 8.783228725],
        },
      ],
    },
  },
  {
    Id: "56fcb3d3-df8d-485e-be24-4b400506b49b",
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: "56fcb3d3-df8d-485e-be24-4b400506b49b",
      Time: "2022-04-22T16:50:31.605597Z",
      Kind: "Measurement",
      TeePosition: [2.130355402, -0.1338209078, -0.09539570021],
      PlayerDexterity: "Left",
      AttackAngle: -2.6,
      LaunchDirection: -0.986,
      BallSpeed: 61.97,
      ClubPath: -2.0,
      ClubSpeed: 36.389,
      DynamicLoft: 28.348,
      DynamicLie: 58.7,
      FaceAngle: -0.717,
      FaceToPath: 1.283,
      LaunchAngle: 13.4,
      SmashFactor: 1.3488,
      SpinAxis: 1.904,
      SpinLoft: 30.987,
      SpinRate: 6095.64,
      SwingDirection: -0.499,
      SwingPlane: 60.975,
      SwingRadius: 1.082,
      DPlaneTilt: 2.24,
      LowPointDistance: 0.054,
      LowPointHeight: -0.001,
      LowPointSide: -0.001,
      ImpactHeight: 0.0,
      ImpactOffset: 0.0004,
      MaxHeight: 31.232,
      Curve: 2.531,
      Carry: 137.386,
      Total: 142.704,
      CarrySide: 0.167,
      TotalSide: 0.227,
      LandingAngle: 51.234565,
      HangTime: 6.121145,
      LastData: 4.148,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.04735931528, 35.51764523, 83.31884869, -4632.900922],
          YFit: [-0.00808711586, -1.46450969, 520.0912567, 2838.298296],
          ZFit: [-0.001948062662, -1.170507555, 289.1192664, 1617.971052],
          TimeInterval: [-0.0262196269, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.04895079634, 27.83273354, -52.31618909, -1602.958481],
          YFit: [-0.007450714506, -1.573643849, 325.7033082, -1540.426533],
          ZFit: [-0.00158094047, -1.153126107, 181.9926727, -842.2939712],
          TimeInterval: [0.0, 0.0527307731],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [
            0.0, 45.25462722, -9.1958389, 1.678847878, -0.1953204147,
            0.01325639531, -0.000376866496,
          ],
          YFit: [
            -0.0, 18.98452598, -1.619927396, -0.7191223445, 0.1310349782,
            -0.0105619862, 0.000308450066,
          ],
          ZFit: [
            -0.0, -0.7792201664, 0.3938804211, -0.0918537906, 0.01348220785,
            -0.001155474736, 4.2720818e-5,
          ],
          SpinRateFit: [
            6098.201988, -201.783469, 19.524567, -2.027282, 0.061168,
          ],
          TimeInterval: [0.0, 6.121145],
          MeasuredTimeInterval: [0.0, 0.085857],
          ValidTimeInterval: [0.0, 6.121145],
        },
        {
          Kind: "Bounce",
          XFit: [121.1494215, 2.839294085, -0.0305734058],
          YFit: [-216.6715956, 65.5213783, -4.921231879],
          ZFit: [-0.01620033801, 0.03201944889, -0.0003447841664],
          TimeInterval: [6.12114535, 7.194089698],
          ValidTimeInterval: [6.12114535, 7.194089698],
        },
        {
          Kind: "Bounce",
          XFit: [121.6004206, 2.736009491, -0.02499661472],
          YFit: [-269.9540417, 72.89106504, -4.916066456],
          ZFit: [-0.01111429318, 0.03085467879, -0.0002818930428],
          TimeInterval: [7.194089698, 7.633156132],
          ValidTimeInterval: [7.194089698, 7.633156132],
        },
        {
          Kind: "Roll",
          XFit: [128.9784697, 1.578604848],
          YFit: [0.0],
          ZFit: [0.07208985074, 0.01780233233],
          TimeInterval: [7.633156132, 8.694480898],
          ValidTimeInterval: [7.633156132, 8.694480898],
        },
      ],
    },
  },
];

const mockDataDrivers = [
  {
    Id: "driver-001",
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: "driver-001",
      Time: "2024-01-15T10:30:00.000Z",
      Kind: "Measurement",
      TeePosition: [2.2, -0.12, -0.05],
      PlayerDexterity: "Right",
      AttackAngle: 2.5,
      LaunchDirection: -1.2,
      BallSpeed: 165.4,
      ClubPath: -0.8,
      ClubSpeed: 110.5,
      DynamicLoft: 11.2,
      DynamicLie: 58.5,
      FaceAngle: -1.5,
      FaceToPath: -0.7,
      LaunchAngle: 11.5,
      SmashFactor: 1.497,
      SpinAxis: -2.1,
      SpinLoft: 13.7,
      SpinRate: 2450.0,
      SwingDirection: -1.8,
      SwingPlane: 48.5,
      SwingRadius: 1.45,
      DPlaneTilt: -3.2,
      LowPointDistance: -0.025,
      LowPointHeight: 0.002,
      LowPointSide: -0.001,
      ImpactHeight: 0.035,
      ImpactOffset: 0.008,
      MaxHeight: 35.2,
      Curve: -3.5,
      Carry: 285.5,
      Total: 305.2,
      CarrySide: -8.2,
      TotalSide: -10.5,
      LandingAngle: 38.5,
      HangTime: 6.8,
      LastData: 6.5,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.045, 108.5, 42.3, -2500.0],
          YFit: [-0.008, -0.65, 380.2, 1450.5],
          ZFit: [-0.002, -0.85, -185.4, -720.3],
          TimeInterval: [-0.03, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.048, 95.2, -28.5, -850.2],
          YFit: [-0.009, -0.55, 195.3, -680.4],
          ZFit: [-0.003, -0.62, -98.7, 485.6],
          TimeInterval: [0.0, 0.055],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [0.0, 49.8, -3.2, 0.45, -0.032, 0.0012, 0.00008],
          YFit: [0.0, 18.5, -1.2, -0.18, 0.028, -0.0018, -0.00001],
          ZFit: [0.0, -1.85, 0.42, -0.08, 0.012, -0.0008, 0.00003],
          SpinRateFit: [2450.5, -75.2, 6.5, -0.68, 0.015],
          TimeInterval: [0.0, 6.8],
          MeasuredTimeInterval: [0.0, 0.12],
          ValidTimeInterval: [0.0, 6.8],
        },
        {
          Kind: "Bounce",
          XFit: [245.5, 9.2, -0.15],
          YFit: [-285.2, 58.5, -4.2],
          ZFit: [-8.5, -1.2, 0.03],
          TimeInterval: [6.8, 7.85],
          ValidTimeInterval: [6.8, 7.85],
        },
        {
          Kind: "Roll",
          XFit: [260.8, 5.5],
          YFit: [0.0],
          ZFit: [-9.2, -0.45],
          TimeInterval: [7.85, 10.2],
          ValidTimeInterval: [7.85, 10.2],
        },
      ],
    },
  },
];

const mockDataWoods = Array.from({ length: 15 }, (_, i) => {
  const baseValues = {
    BallSpeed: 155.8,
    LaunchAngle: 13.2,
    SpinRate: 3150.0,
    Carry: 245.8,
    ClubSpeed: 102.3,
    AttackAngle: 1.2,
  };

  const variation = {
    BallSpeed: (Math.random() - 0.5) * 16,      // ±8 mph
    LaunchAngle: (Math.random() - 0.5) * 4,     // ±2 degrees
    SpinRate: (Math.random() - 0.5) * 600,      // ±300 rpm
    Carry: (Math.random() - 0.5) * 30,          // ±15 yards
    ClubSpeed: (Math.random() - 0.5) * 10,      // ±5 mph
    AttackAngle: (Math.random() - 0.5) * 3,     // ±1.5 degrees
  };

  const ballSpeed = baseValues.BallSpeed + variation.BallSpeed;
  const launchAngle = baseValues.LaunchAngle + variation.LaunchAngle;
  const spinRate = baseValues.SpinRate + variation.SpinRate;
  const carry = baseValues.Carry + variation.Carry;
  const clubSpeed = baseValues.ClubSpeed + variation.ClubSpeed;
  const attackAngle = baseValues.AttackAngle + variation.AttackAngle;
  const smashFactor = ballSpeed / clubSpeed;

  return {
    Id: `wood-${String(i + 1).padStart(3, '0')}`,
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: `wood-${String(i + 1).padStart(3, '0')}`,
      Time: `2024-01-15T10:${35 + i}:00.000Z`,
      Kind: "Measurement",
      TeePosition: [2.18 + (Math.random() - 0.5) * 0.1, -0.115 + (Math.random() - 0.5) * 0.02, -0.04 + (Math.random() - 0.5) * 0.02],
      PlayerDexterity: "Right",
      AttackAngle: attackAngle,
      LaunchDirection: -2.5 + (Math.random() - 0.5) * 2,
      BallSpeed: ballSpeed,
      ClubPath: -1.5 + (Math.random() - 0.5) * 1.5,
      ClubSpeed: clubSpeed,
      DynamicLoft: 13.5 + (Math.random() - 0.5) * 2,
      DynamicLie: 59.8 + (Math.random() - 0.5) * 2,
      FaceAngle: -3.2 + (Math.random() - 0.5) * 2,
      FaceToPath: -1.7 + (Math.random() - 0.5) * 1.5,
      LaunchAngle: launchAngle,
      SmashFactor: smashFactor,
      SpinAxis: -4.5 + (Math.random() - 0.5) * 3,
      SpinLoft: 14.7 + (Math.random() - 0.5) * 2,
      SpinRate: spinRate,
      SwingDirection: -2.3 + (Math.random() - 0.5) * 2,
      SwingPlane: 52.5 + (Math.random() - 0.5) * 3,
      SwingRadius: 1.38 + (Math.random() - 0.5) * 0.08,
      DPlaneTilt: -5.8 + (Math.random() - 0.5) * 2,
      LowPointDistance: -0.015 + (Math.random() - 0.5) * 0.02,
      LowPointHeight: 0.001 + (Math.random() - 0.5) * 0.002,
      LowPointSide: -0.002 + (Math.random() - 0.5) * 0.004,
      ImpactHeight: 0.028 + (Math.random() - 0.5) * 0.01,
      ImpactOffset: 0.012 + (Math.random() - 0.5) * 0.008,
      MaxHeight: 32.5 + (Math.random() - 0.5) * 5,
      Curve: -6.2 + (Math.random() - 0.5) * 4,
      Carry: carry,
      Total: carry + 16.7 + (Math.random() - 0.5) * 5,
      CarrySide: -12.5 + (Math.random() - 0.5) * 8,
      TotalSide: -15.2 + (Math.random() - 0.5) * 10,
      LandingAngle: 42.5 + (Math.random() - 0.5) * 4,
      HangTime: 6.2 + (Math.random() - 0.5) * 0.8,
      LastData: 5.9 + (Math.random() - 0.5) * 0.6,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.042, 100.5, 38.5, -2200.5],
          YFit: [-0.009, -0.72, 355.8, 1350.2],
          ZFit: [-0.003, -0.95, -175.2, -680.5],
          TimeInterval: [-0.032, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.045, 88.5, -25.2, -780.5],
          YFit: [-0.01, -0.62, 182.5, -620.8],
          ZFit: [-0.003, -0.68, -92.5, 445.2],
          TimeInterval: [0.0, 0.052],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [0.0, 45.2, -4.1, 0.58, -0.045, 0.0015, 0.00009],
          YFit: [0.0, 16.8, -1.8, -0.22, 0.035, -0.0022, -0.00002],
          ZFit: [0.0, -2.35, 0.55, -0.095, 0.015, -0.001, 0.000035],
          SpinRateFit: [spinRate, -95.5, 8.2, -0.85, 0.018],
          TimeInterval: [0.0, 6.2],
          MeasuredTimeInterval: [0.0, 0.115],
          ValidTimeInterval: [0.0, 6.2],
        },
        {
          Kind: "Bounce",
          XFit: [210.5, 8.5, -0.18],
          YFit: [-245.8, 52.8, -4.5],
          ZFit: [-10.2, -1.45, 0.038],
          TimeInterval: [6.2, 7.15],
          ValidTimeInterval: [6.2, 7.15],
        },
        {
          Kind: "Roll",
          XFit: [225.2, 4.8],
          YFit: [0.0],
          ZFit: [-11.5, -0.52],
          TimeInterval: [7.15, 9.5],
          ValidTimeInterval: [7.15, 9.5],
        },
      ],
    },
  };
});

const mockDataHybrids = [
  {
    Id: "hybrid-001",
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: "hybrid-001",
      Time: "2022-03-30T18:17:38.945278Z",
      Kind: "Measurement",
      TeePosition: [2.157145963, -0.1203743218, -0.05251557697],
      PlayerDexterity: "Right",
      AttackAngle: -1.8,
      LaunchDirection: -6.228,
      BallSpeed: 125.8,
      ClubPath: -2.2,
      ClubSpeed: 30.211,
      DynamicLoft: 24.128,
      DynamicLie: 62.2,
      FaceAngle: -7.18,
      FaceToPath: -4.98,
      LaunchAngle: 14.2,
      SmashFactor: 1.339,
      SpinAxis: -8.536,
      SpinLoft: 26.479,
      SpinRate: 4235.23,
      SwingDirection: -3.627,
      SwingPlane: 57.026,
      SwingRadius: 1.236,
      DPlaneTilt: -10.007,
      LowPointDistance: 0.046,
      LowPointHeight: -0.001,
      LowPointSide: -0.002,
      ImpactHeight: 0.0057,
      ImpactOffset: 0.0073,
      MaxHeight: 15.558,
      Curve: -5.783,
      Carry: 109.712,
      Total: 124.647,
      CarrySide: -17.635,
      TotalSide: -20.669,
      LandingAngle: 36.444958,
      HangTime: 4.461307,
      LastData: 4.023,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.05076473265, 29.51996687, 37.12893058, -2085.024379],
          YFit: [-0.009812867884, -0.8996462862, 299.5004423, 1207.388538],
          ZFit: [-0.003258066886, -1.249510135, -197.6917886, -653.9701157],
          TimeInterval: [-0.03295238442, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.05133515774, 22.27443297, -35.83562886, -702.97206],
          YFit: [-0.009719798193, -0.8365410492, 171.4507016, -588.5483144],
          ZFit: [-0.003282419561, -0.8404201735, -109.5890296, 427.859832],
          TimeInterval: [0.0, 0.05306361558],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [
            -0.0, 37.90980616, -5.717755818, 0.903744139, -0.08385329977,
            0.002720688132, 0.000142241524,
          ],
          YFit: [
            0.0, 13.50027448, -2.449915518, -0.3388768555, 0.06559981182,
            -0.004154471221, -2.744194e-6,
          ],
          ZFit: [
            -0.0, -4.137061552, -0.03756490404, 0.05026719863, -0.01300117049,
            0.001693550034, -9.3430849e-5,
          ],
          SpinRateFit: [
            4235.873139, -132.083763, 11.324829, -1.195791, 0.022459,
          ],
          TimeInterval: [0.0, 4.461307],
          MeasuredTimeInterval: [0.0, 0.100987],
          ValidTimeInterval: [0.0, 4.461307],
        },
        {
          Kind: "Bounce",
          XFit: [74.52630084, 8.438410562, -0.1954497887],
          YFit: [-120.2178164, 49.62423094, -5.082968342],
          ZFit: [-10.63696351, -1.749204903, 0.04051494377],
          TimeInterval: [4.46130699, 5.303065511],
          ValidTimeInterval: [4.46130699, 5.303065511],
        },
        {
          Kind: "Bounce",
          XFit: [74.76030968, 8.31302104, -0.1802325492],
          YFit: [-152.2883081, 55.59594882, -5.068553819],
          ZFit: [-10.68547146, -1.723212785, 0.03736054778],
          TimeInterval: [5.303065511, 5.665940792],
          ValidTimeInterval: [5.303065511, 5.665940792],
        },
        {
          Kind: "Roll",
          XFit: [96.57126175, 3.442313932],
          YFit: [0.0],
          ZFit: [-15.20668117, -0.7135600194],
          TimeInterval: [5.665940792, 7.654738431],
          ValidTimeInterval: [5.665940792, 7.654738431],
        },
      ],
    },
  },
];

const mockDataWedges = Array.from({ length: 20 }, (_, i) => {
  const baseValues = {
    BallSpeed: 92.5,
    LaunchAngle: 24.5,
    SpinRate: 8500.0,
    Carry: 102.8,
    ClubSpeed: 72.5,
    AttackAngle: -4.2,
  };

  const variation = {
    BallSpeed: (Math.random() - 0.5) * 14,      // ±7 mph
    LaunchAngle: (Math.random() - 0.5) * 6,     // ±3 degrees
    SpinRate: (Math.random() - 0.5) * 2000,     // ±1000 rpm
    Carry: (Math.random() - 0.5) * 28,          // ±14 yards
    ClubSpeed: (Math.random() - 0.5) * 12,      // ±6 mph
    AttackAngle: (Math.random() - 0.5) * 3,     // ±1.5 degrees
  };

  const ballSpeed = baseValues.BallSpeed + variation.BallSpeed;
  const launchAngle = baseValues.LaunchAngle + variation.LaunchAngle;
  const spinRate = baseValues.SpinRate + variation.SpinRate;
  const carry = baseValues.Carry + variation.Carry;
  const clubSpeed = baseValues.ClubSpeed + variation.ClubSpeed;
  const attackAngle = baseValues.AttackAngle + variation.AttackAngle;
  const smashFactor = ballSpeed / clubSpeed;

  return {
    Id: `wedge-${String(i + 1).padStart(3, '0')}`,
    Type: "Measurement",
    SubType: "Golf",
    Payload: {
      Id: `wedge-${String(i + 1).padStart(3, '0')}`,
      Time: `2024-01-15T10:${45 + i}:00.000Z`,
      Kind: "Measurement",
      TeePosition: [2.08 + (Math.random() - 0.5) * 0.08, -0.118 + (Math.random() - 0.5) * 0.02, -0.075 + (Math.random() - 0.5) * 0.025],
      PlayerDexterity: "Right",
      AttackAngle: attackAngle,
      LaunchDirection: -3.2 + (Math.random() - 0.5) * 4,
      BallSpeed: ballSpeed,
      ClubPath: -3.8 + (Math.random() - 0.5) * 3,
      ClubSpeed: clubSpeed,
      DynamicLoft: 50.5 + (Math.random() - 0.5) * 6,
      DynamicLie: 63.8 + (Math.random() - 0.5) * 3,
      FaceAngle: -4.5 + (Math.random() - 0.5) * 4,
      FaceToPath: -1.2 + (Math.random() - 0.5) * 2.5,
      LaunchAngle: launchAngle,
      SmashFactor: smashFactor,
      SpinAxis: -2.8 + (Math.random() - 0.5) * 5,
      SpinLoft: 54.7 + (Math.random() - 0.5) * 5,
      SpinRate: spinRate,
      SwingDirection: -3.5 + (Math.random() - 0.5) * 3,
      SwingPlane: 61.5 + (Math.random() - 0.5) * 4,
      SwingRadius: 1.02 + (Math.random() - 0.5) * 0.1,
      DPlaneTilt: -6.5 + (Math.random() - 0.5) * 3,
      LowPointDistance: 0.085 + (Math.random() - 0.5) * 0.025,
      LowPointHeight: -0.003 + (Math.random() - 0.5) * 0.002,
      LowPointSide: -0.004 + (Math.random() - 0.5) * 0.005,
      ImpactHeight: -0.008 + (Math.random() - 0.5) * 0.008,
      ImpactOffset: 0.016 + (Math.random() - 0.5) * 0.012,
      MaxHeight: 20.5 + (Math.random() - 0.5) * 6,
      Curve: -3.2 + (Math.random() - 0.5) * 4,
      Carry: carry,
      Total: carry + 4.5 + (Math.random() - 0.5) * 3,
      CarrySide: -5.5 + (Math.random() - 0.5) * 8,
      TotalSide: -6.2 + (Math.random() - 0.5) * 9,
      LandingAngle: 50.5 + (Math.random() - 0.5) * 6,
      HangTime: 4.9 + (Math.random() - 0.5) * 0.8,
      LastData: 4.6 + (Math.random() - 0.5) * 0.5,
      ClubTrajectory: [
        {
          Kind: "PreImpact",
          XFit: [-0.05, 70.5, 26.8, -1580.5],
          YFit: [-0.014, -1.02, 275.8, 1025.5],
          ZFit: [-0.006, -1.38, -140.5, -565.8],
          TimeInterval: [-0.034, 0.0],
        },
        {
          Kind: "PostImpact",
          XFit: [-0.054, 63.5, -17.2, -560.8],
          YFit: [-0.015, -0.85, 142.8, -465.5],
          ZFit: [-0.006, -0.88, -72.5, 352.8],
          TimeInterval: [0.0, 0.047],
        },
      ],
      BallTrajectory: [
        {
          Kind: "Flight",
          XFit: [0.0, 27.2, -6.5, 0.92, -0.072, 0.0023, 0.00011],
          YFit: [0.0, 9.8, -3.1, -0.34, 0.051, -0.0031, -0.00004],
          ZFit: [0.0, -4.65, 0.85, -0.145, 0.024, -0.0015, 0.00005],
          SpinRateFit: [spinRate, -252.5, 21.8, -2.28, 0.047],
          TimeInterval: [0.0, 4.9],
          MeasuredTimeInterval: [0.0, 0.093],
          ValidTimeInterval: [0.0, 4.9],
        },
        {
          Kind: "Bounce",
          XFit: [85.5, 2.8, -0.078],
          YFit: [-102.5, 26.8, -3.1],
          ZFit: [-17.5, -2.05, 0.055],
          TimeInterval: [4.9, 5.32],
          ValidTimeInterval: [4.9, 5.32],
        },
        {
          Kind: "Roll",
          XFit: [88.8, 2.5],
          YFit: [0.0],
          ZFit: [-19.2, -0.65],
          TimeInterval: [5.32, 6.45],
          ValidTimeInterval: [5.32, 6.45],
        },
      ],
    },
  };
});

// Map club types to their corresponding mock data
const mockDataByClubType = {
  Drivers: mockDataDrivers,
  Irons: mockDataIrons,
  Hybrid: mockDataWoods,
  Wood: mockDataWoods,
  Wedge: mockDataWedges,
};

function timeDelay() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve("resolved");
    }, 2000);
  });
}

class WebSocketConnection {
  constructor() {
    this.address = "";
    this.connected = false;
    this.websocket = undefined;
    this.setConnectionStatus = undefined;
    this.data = [];
    this.onMessageCallback = undefined;
    this.mockCalls = false;
    this.captureData = false;
  }
  _onOpen = () => {
    this.connected = true;
    if (this.setConnectionStatus) {
      this.setConnectionStatus("true");
    }
    var msg;
    if (this.mockCalls) {
      msg = {
        type: "subscribe",
        channel: "marketdata",
        interval: 100,
        market_id: "BTC-USDT",
        filter: ["ticker", "order_books"],
      };
    } else {
      msg = { Type: "Subscribe", Payload: { MessageList: ["Measurement"] } };
    }

    this.websocket.send(JSON.stringify(msg));
  };
  _onClose = () => {
    if (this.setConnectionStatus) {
      this.setConnectionStatus(this.connected ? "false" : "error");
    }
    this.connected = false;
  };
  _onMessage = (event) => {
    if (this.mockCalls && this.captureData) {
      const clubType = localStorage.getItem("clubType") || "Drivers";
      const maxSwings = clubType === "Hybrid" ? 20 : 20;

      if (this.data.length < maxSwings) {
        const currentMockData = mockDataByClubType[clubType] || mockDataDrivers;
        var mockEvent = currentMockData[this.data.length % currentMockData.length];
        this.data.push({
          key: this.data.length > 0 ? this.data[this.data.length - 1].key + 1 : 0,
          data: this.formatMessage(mockEvent.Payload),
        });
        if (this.onMessageCallback) {
          this.onMessageCallback(this.data);
        }
      }
    } else if (!this.mockCalls && this.captureData) {
      var eventJson = JSON.parse(event.data);
      if (
        eventJson.Type === "Measurement" &&
        eventJson.Payload.Kind === "Measurement"
      ) {
        this.data.push({
          key:
            this.data.length > 0 ? this.data[this.data.length - 1].key + 1 : 0,
          data: this.formatMessage(eventJson.Payload),
        });
        if (this.onMessageCallback) {
          this.onMessageCallback(this.data);
        }
      } else if (eventJson.Type === "Ping") {
        this.websocket.send(JSON.stringify({ Type: "Pong" }));
      }
    } else if (!this.mockCalls) {
      var eventJson = JSON.parse(event.data);
      if (eventJson.Type === "Ping") {
        this.websocket.send(JSON.stringify({ Type: "Pong" }));
      }
    }
  };
  formatMessage = (message) => {
    var userDexterity = localStorage.getItem("rightHanded") === "true" ? "Right" : "Left";
    var userGender = localStorage.getItem("gender");
    
    var formattedMessage = {
      AttackAngle: message.AttackAngle,
      BallSpeed: message.BallSpeed,
      Carry: message.Carry,
      CarrySide: message.CarrySide,
      ClubPath: message.ClubPath,
      ClubSpeed: message.ClubSpeed,
      DplaneTilt: message.DPlaneTilt,
      DynamicLoft: message.DynamicLoft,
      FaceAngle: message.FaceAngle,
      FaceToPath: message.FaceToPath,
      LandingAngle: message.LandingAngle,
      LaunchAngle: message.LaunchAngle,
      LaunchDirection: message.LaunchDirection,
      MaxHeight: message.MaxHeight,
      PlayerDexterity: userDexterity,
      Gender: userGender,
      SmashFactor: message.SmashFactor,
      SpinAxis: message.SpinAxis,
      SpinLoft: message.SpinLoft,
      SpinRate: message.SpinRate,
      SwingDirection: message.SwingDirection,
      SwingPlane: message.SwingPlane,
      StrokesTime: message.Time,
    };
    return formattedMessage;
  };
  setOnMessageCallback = (callback) => {
    this.onMessageCallback = callback;
    if (this.mockCalls) {
      this.generateMessage();
    }
  };
  _onError = () => {
    this.connected = false;
    if (this.setConnectionStatus) {
      this.setConnectionStatus("error");
    }
  };
  saveDataToLocal = (shaft, head) => {
    if (this.data.length > 0) {
      var sessionData = JSON.parse(localStorage.getItem("sessionData")) || {
        swingData: [],
        headSuggestions: [],
        shaftSuggestions: [],
      };
      var newData = { shaft, head, data: this.data.map((event) => event.data) };
      sessionData.swingData.push(newData);
      localStorage.setItem(
        "sessionData",
        JSON.stringify({
          swingData: sessionData.swingData,
          headSuggestions: sessionData.headSuggestions,
          shaftSuggestions: sessionData.shaftSuggestions,
        })
      );
      this.clearGatheredData();
    }
  };
  clearGatheredData() {
    this.data = [];
  }
  connect(address, setConnectionStatus, mockCalls) {
    if (this.connected) {
      this.setConnectionStatus = undefined;
      this.websocket.close();
    }
    this.setConnectionStatus = setConnectionStatus;
    var url;
    if (mockCalls) {
      url = "wss://" + address + "/api/exchange/v1/ws";
    } else {
      url = "ws://" + address + "/ws";
    }
    this.websocket = new WebSocket(url);
    this.websocket.onopen = this._onOpen;
    this.websocket.onclose = this._onClose;
    this.websocket.onerror = this._onError;
    this.websocket.onmessage = this._onMessage;
    this.mockCalls = mockCalls;
  }
  formatDataForScoring = () => {
    var sessionData = JSON.parse(localStorage.getItem("sessionData"));
    var dataToSend = [];
    sessionData.swingData.forEach((swingSession) => {
      swingSession.data.forEach((swing) => {
        if (!Object.values(swing).some((it) => it === (null || undefined))) {
          if (Object.keys(swing).length > 21) {
            let arrayVal = [];
            arrayVal.push(swing.AttackAngle);
            arrayVal.push(swing.BallSpeed);
            arrayVal.push(swing.Carry);
            arrayVal.push(swing.CarrySide);
            arrayVal.push(swing.ClubPath);
            arrayVal.push(swing.ClubSpeed);
            arrayVal.push(swing.DplaneTilt);
            arrayVal.push(swing.DynamicLoft);
            arrayVal.push(swing.FaceAngle);
            arrayVal.push(swing.FaceToPath);
            arrayVal.push(swing.LandingAngle);
            arrayVal.push(swing.LaunchAngle);
            arrayVal.push(swing.LaunchDirection);
            arrayVal.push(swing.MaxHeight);
            arrayVal.push(swing.PlayerDexterity);
            arrayVal.push(swing.Gender);
            arrayVal.push(swing.SmashFactor);
            arrayVal.push(swing.SpinAxis);
            arrayVal.push(swing.SpinLoft);
            arrayVal.push(swing.SpinRate);
            arrayVal.push(swing.SwingDirection);
            arrayVal.push(swing.SwingPlane);
            arrayVal.push(swing.StrokesTime);
            dataToSend.push(arrayVal);
          }
        }
      });
    });
    return dataToSend;
  };
  generateMessage = async () => {
    while (true) {
      await timeDelay();
      if (this.onMessageCallback && this.captureData) {
        this._onMessage();
      }
    }
  };
}

export default new WebSocketConnection();
